import CatalogReducer from './CatalogReducer';

const reducers = {
	catalog: CatalogReducer
};

export default reducers;
